import {
    useState
} from "react";
import {
    useDispatch
} from "react-redux";


const useStatusThunk = (thunk) => {
    const dis = useDispatch();
    const [status, setStatus] = useState();
    const [error, setError] = useState();

    
    const event = {
        onSuccess: () => {},
        onFailure: () => {},
        onPending: () => {}

    }

    const dispatch = async (params) => {
     
        setStatus("pending");
    
        event.onPending();
       
        const response = await dis(
            thunk(params)
        );

        if (thunk.fulfilled.type === response.type) {
            setStatus("success");
            
            event.onSuccess();
        } else if (thunk.rejected.type === response.type) {
            setStatus("failure");
            event.onFailure();

            //set error
            if (response.payload) {
                if (response.payload.response) {
                    setError(response.payload.response.data.error.message);
                } else {
                    setError("No response from server.");
                }
            } else {
                setError(response.error.message);
            }
        } else {
            setStatus("failure");
        }
    }

    return [
        dispatch,
        status,
        error,
        event
    ];
}

export default useStatusThunk;